export default "__VITE_ASSET__DlSVQ1k___"